import { createAction } from "@reduxjs/toolkit";

export function createOptionalAction<T = void>(type: string) {
    return createAction(type, (payload?: T) => ({ payload }));
}
